import { render, staticRenderFns } from "./TemplateBank.vue?vue&type=template&id=77d070f8"
import script from "./TemplateBank.vue?vue&type=script&lang=js"
export * from "./TemplateBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports